module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9599.b7b99b05.jpg";